// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Accordion__container___2Qw4w{border:1px solid #eae9e3;border-radius:8px}@media (max-width:719px){.Accordion__container___2Qw4w{padding:24px}}.Accordion__header___3mSZ_{color:inherit;font-weight:400;font-size:20px;line-height:32px;display:flex;align-items:center;justify-content:space-between;font-weight:500}.Accordion__body___16t1Q{height:0;overflow:hidden;color:#6b6651;transition:height .2s ease-out}.Accordion__content___38VRB{padding:0 32px 24px}.Accordion__title___26-Ty{max-width:90%;padding:24px 32px}.Accordion__title___26-Ty h3{margin-bottom:0}.Accordion__cta___34Idv{margin:24px 0 0;text-align:center}.Accordion__cursor___2KXu5{cursor:pointer}.Accordion__iconContainer___IqChg{display:flex;align-items:center;padding-right:24px}.Accordion__toggleIcon___iCDoN{transition:transform .2s ease-out}.Accordion__rotate___qXLen{transform:rotate(-180deg)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xsmall": "540px",
	"small": "720px",
	"medium": "960px",
	"large": "1280px",
	"container": "Accordion__container___2Qw4w",
	"header": "Accordion__header___3mSZ_",
	"body": "Accordion__body___16t1Q",
	"content": "Accordion__content___38VRB",
	"title": "Accordion__title___26-Ty",
	"cta": "Accordion__cta___34Idv",
	"cursor": "Accordion__cursor___2KXu5",
	"iconContainer": "Accordion__iconContainer___IqChg",
	"toggleIcon": "Accordion__toggleIcon___iCDoN",
	"rotate": "Accordion__rotate___qXLen"
};
module.exports = ___CSS_LOADER_EXPORT___;
